import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

const messages = defineMessages({
  gridView: {
    id: 'autoCuration.pdfSplitEditor.view.grid',
    defaultMessage: 'Grid View',
  },
  listView: {
    id: 'autoCuration.pdfSplitEditor.view.list',
    defaultMessage: 'List View',
  },
});

interface ViewToggleProps {
  viewMode: 'grid' | 'standard';
  onToggleViewMode: () => void;
}

export const ViewToggle = ({ onToggleViewMode, viewMode }: ViewToggleProps) => {
  const { formatMessage } = useIntl();
  return (
    <Tooltip
      title={formatMessage(
        viewMode === 'standard' ? messages.gridView : messages.listView
      )}
    >
      <IconButton
        onClick={onToggleViewMode}
        sx={{
          bgcolor: 'primary.50',
          color: 'primary.main',
          border: '1px solid',
          borderColor: 'primary.main',
          '&:hover': {
            bgcolor: 'primary.main',
            color: 'white',
          },
        }}
      >
        {viewMode === 'standard' ? (
          <Icon name="grid" type="fas" />
        ) : (
          <Icon name="list" type="fas" />
        )}
      </IconButton>
    </Tooltip>
  );
};
